import { HarSanitizerRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/har-sanitizer/$')({
  component: HarSanitizerRoute,
});
